module.exports = __webpack_public_path__ + "static/assets/ea846e4b911f64bc4496e4af00c2b3a4.svg";